import styled from '@emotion/styled';
import { Container } from '@presentation/components';
import { mediaQuery } from '@presentation/styles';

export const PageContainer = styled(Container)`
  margin-bottom: 100px;
  ${mediaQuery('small')} {
    margin-bottom: 50px;
  }
`;

export const ButtonsWrapper = styled(Container)`
  display: flex;
  align-items: center;
  justify-content: space-evenly;
`;

export const ParentContainer = styled.div`
  margin-bottom: 50px;
  display: flex;

  & > *:not(:last-child) {
    margin-right: 30px;
  }

  ${mediaQuery('tablet')} {
    margin-bottom: 0;
    & > *:not(:last-child) {
      margin-bottom: 30px;
    }
    flex-direction: column;
  }
`;
